<div class="contain" [attr.automation-id]="item.subjectId" (mouseenter)="showRemoveIcon = true" (mouseleave)="showRemoveIcon = false">
    <div
        *ngIf="showRemoveIcon"
        class="badge remove"
        [matTooltip]="'Layouts.Masthead.USER_NOTIFICATIONS.clearTooltip' | translate"
        (click)="removeNotification()"
    >
        <p-icon class="x" name="x"></p-icon>
    </div>
    <header>
        <span id="name">{{ item.senderUserName }}</span> <span id="time">{{ item.changedDate }}</span>
    </header>
    <div class="subject" *ngLet="selectedProjectId$ | async as selectedProjectId">
        <a [href]="item.linkPath" (click)="itemClicked($event, selectedProjectId)"> {{ item.linkTitle }} </a>
    </div>

    <footer>
        <span *ngFor="let name of item.contentUsers; let first = first" [ngClass]="{ isFirst: first }"
            ><p-chip [label]="name"></p-chip
        ></span>
        <span class="content">{{ item.content }}</span>
    </footer>
</div>
